module.exports = __webpack_public_path__ + "media/loans/bank-building-eb920983.svg";